var exports = {
  "kL": "RichPresenceCard.module__container___Snd1Z2",
  "Nr": "RichPresenceCard.module__card___Snd1Z2",
  "U1": "RichPresenceCard.module__headerRow___Snd1Z2",
  "FA": "RichPresenceCard.module__headerTitleGroup___Snd1Z2",
  "Oc": "RichPresenceCard.module__serviceHeaderIcon___Snd1Z2",
  "JP": "RichPresenceCard.module__headerMenuDots___Snd1Z2",
  "VR": "RichPresenceCard.module__bodyRow___Snd1Z2",
  "c6": "RichPresenceCard.module__assetWrapper___Snd1Z2",
  "nX": "RichPresenceCard.module__largeImage___Snd1Z2",
  "th": "RichPresenceCard.module__largeImageFallback___Snd1Z2",
  "hT": "RichPresenceCard.module__vsCodeKeyboardBox___Snd1Z2",
  "Kq": "RichPresenceCard.module__spotifyFallbackBox___Snd1Z2",
  "bh": "RichPresenceCard.module__appleMusicFallbackBox___Snd1Z2",
  "rp": "RichPresenceCard.module__smallImage___Snd1Z2",
  "RC": "RichPresenceCard.module__detailsCol___Snd1Z2",
  "J7": "RichPresenceCard.module__activityName___Snd1Z2",
  "mr": "RichPresenceCard.module__detailLine___Snd1Z2",
  "qo": "RichPresenceCard.module__stateLine___Snd1Z2",
  "Ed": "RichPresenceCard.module__timerLine___Snd1Z2",
  "J$": "RichPresenceCard.module__timerIcon___Snd1Z2",
  "nh": "RichPresenceCard.module__musicProgressRow___Snd1Z2",
  "wM": "RichPresenceCard.module__musicTimeText___Snd1Z2",
  "jI": "RichPresenceCard.module__musicProgressBarTrack___Snd1Z2",
  "Dz": "RichPresenceCard.module__musicProgressBarFill___Snd1Z2",
  "v0": "RichPresenceCard.module__buttonRow___Snd1Z2",
  "hP": "RichPresenceCard.module__actionButton___Snd1Z2",
};

module.exports = exports;
